import React from "react";
import { IFaqEntry } from "../../interfaces";

const entries: Array<IFaqEntry> = [];
export default entries;

entries.push({ question: "Já pode jogar?", answer: <>Sim.</> });
